import { render } from "./DashboardModera.vue?vue&type=template&id=9e9b989c&ts=true"
import script from "./DashboardModera.vue?vue&type=script&lang=ts"
export * from "./DashboardModera.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__